import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.array.find";
// client js begin
import util from '@tencent/vft-common/util';
// client js end

export default function (p, ctxInfo) {
  // console.log($ctx)
  // 根据$ctx是否为undefined判断环境是处于服务端还是客户端
  if (typeof $ctx === 'undefined' && !ctxInfo) {
    return util.getUrlParam(p);
  } else if (typeof $ctx !== 'undefined') {
    return $ctx.request.query[p]; // 服务端逻辑
  } else {
    var _ref = ctxInfo || {},
      query = _ref.query;
    if (!query) return '';
    var queryResult = query.split('&').map(function (item) {
      return {
        key: item.split('=')[0],
        value: item.split('=')[1] || ''
      };
    }).find(function (item) {
      return item.key === p;
    });
    return (queryResult === null || queryResult === void 0 ? void 0 : queryResult.value) || '';
  }
}